<!-- 计费管理 -->
<template>
  <div>
    <div class="select-box clearfix">
      <div class="item-select-box">
        <span class="item-select-title item-select-title-4">关键词：</span>
        <div class="item-select-content">
          <el-input v-model="selectenObj.keyWord" placeholder="公司名称或联系人姓名" clearable></el-input>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="item-select-box">
        <span class="item-select-title item-select-title-7">剩余日数：</span>
        <div class="item-select-content range-box clearfix">
          <el-input v-model="selectenObj.startSurplusDays" placeholder="请输入" clearable></el-input>
          <span class="range-span">-</span>
          <el-input v-model="selectenObj.endSurplusDays" placeholder="请输入" clearable></el-input>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="item-select-box li-min-width">
        <span class="item-select-title item-select-title-4">公司类型：</span>
        <div class="item-select-content">
          <el-select v-model="selectenObj.companyType" placeholder="请选择">
            <el-option
              v-for="(item,index) in lxOptions"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="item-select-box li-min-width">
        <span class="item-select-title item-select-title-4">用户类型：</span>
        <div class="item-select-content">
          <el-select v-model="selectenObj.userType" placeholder="请选择">
            <el-option
              v-for="(item,index) in yhOptions"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="item-select-box li-min-width">
        <span class="item-select-title item-select-title-4">当前状态：</span>
        <div class="item-select-content">
          <el-select v-model="selectenObj.state" placeholder="请选择">
            <el-option
              v-for="(item,index) in ztOptions"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="item-select-box">
        <span class="item-select-title item-select-title-4">付费方式：</span>
        <div class="item-select-content">
          <el-select v-model="selectenObj.paymentMethod" placeholder="请选择">
            <el-option
              v-for="(item,index) in paymentMethodOptions"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="item-select-box">
        <span class="item-select-title item-select-title-7">接口使用量(万次)：</span>
        <div class="item-select-content range-box clearfix">
          <el-input v-model="selectenObj.startInterUseCount" placeholder="请输入" clearable></el-input>
          <span class="range-span">-</span>
          <el-input v-model="selectenObj.endInterUseCount" placeholder="请输入" clearable></el-input>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="clearfix"></div>
      <a @click="selectFun()" class="select-box-btn">查询</a>
    </div>
    
    <div class="result-box">
      <div class="result-box-title clearfix">
        <p>共<span>{{resultDataTotal}}</span>个用户</p>
      </div>
      <div class="result-box-content clearfix">
        <el-table
          :data="resultData"
          border
          header-row-class-name="tableHead"
          style="width: 100%">
          <el-table-column
            label="序号"
            align="center"
            width="50">
            <template slot-scope="scope">
              {{(currentPage-1)*pagesize+scope.$index+1}}
            </template>
          </el-table-column>
          <el-table-column
            label="公司名称"
            prop="comName"
            width="325">
          </el-table-column>
          <el-table-column
            label="公司类型"
            width="110">
            <template slot-scope="scope">
              {{$common.toStr(scope.row.comType,dictionary.com_type)}}
            </template>
          </el-table-column>
          <el-table-column
            label="渠道名"
            width="140">
            <template slot-scope="scope">
              <!-- {{$common.toStr(scope.row.channelId,qdOptions)}} -->
              <span>{{scope.row.channelName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="当前状态"
            width="100">
            <template slot-scope="scope">
              {{$common.toStr(scope.row.userStatus,dictionary.user_status)}}
            </template>
          </el-table-column>
          <el-table-column
            label="上线期限"
            width="240">
            <template slot-scope="scope">
              <span v-if="scope.row.startTime">{{scope.row.startTime}} 至 </span><span>{{scope.row.endTime}}</span>
              <span v-if="!scope.row.startTime">-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="onLineUsedDays"
            label="使用日数"
            width="140">
          </el-table-column>
          <el-table-column
            prop="onLineRemainDays"
            label="剩余日数"
            width="140">
            <template slot-scope="scope">
              <span v-if="scope.row.onLineRemainDays || scope.row.onLineRemainDays==0">{{scope.row.onLineRemainDays}}</span>
              <span v-if="!scope.row.onLineRemainDays && scope.row.onLineRemainDays!=0">-</span>
            </template>
          </el-table-column>
         <el-table-column
            label="付费方式"
            width="153">
            <template slot-scope="scope">
              {{$common.toStr1(scope.row.paymentType,dictionary.payment_type)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="usedOnLineTotal"
            label="接口使用量"
            width="140">
          </el-table-column>
          <el-table-column
            label="操作"
            width="100">
            <template slot-scope="scope">
              <a @click="detailsFun(scope.row.userId,scope.row.paymentType)">查看</a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-if="resultDataTotal>10"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pagesize"
          :total="resultDataTotal">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import vue from 'vue'
export default {
  name: 'UserManagement',
  data () {
    return {
      selectenObj:{
        keyWord:'',
        companyType:'',
        userType:'',
        startSurplusDays:'',
        endSurplusDays:'',
        startInterUseCount:'',
        endInterUseCount:'',
        state:'',
        paymentMethod:''
      },
      resultDataTotal:0,
      currentPage:1,
      pagesize:10,
      dictionary:JSON.parse(localStorage.getItem('dictionary')),
      qdOptions:[],
      resultData: [],
      ztOptions:[],
      lxOptions:[],
      yhOptions:[],
      paymentMethodOptions:[],
    }
  },
  mounted () {
    var _this=this;
    var allObj=new Object();
    allObj.name="全部";
    allObj.value="";
    _this.lxOptions.push(allObj);
    _this.dictionary.com_type.forEach(function(item){
      _this.lxOptions.push(item);
    });
    _this.ztOptions.push(allObj);
    _this.dictionary.user_status.forEach(function(item){
      _this.ztOptions.push(item);
    });
    _this.yhOptions.push(allObj);
    _this.dictionary.user_type.forEach(function(item){
      _this.yhOptions.push(item);
    });
    _this.paymentMethodOptions.push(allObj);
    _this.dictionary.payment_type.forEach(function(item){
      _this.paymentMethodOptions.push(item);
    });
    _this.getQdFun();
    _this.clickSelectFun();
  },
  methods:{
    // 分页
    handleCurrentChange:function(val) {
      var _this=this;
      _this.currentPage = val;
      _this.clickSelectFun();
    },
    clickSelectFun: function(){
      var _this=this;
      if(!this.$common.isNum(_this.selectenObj.startSurplusDays) && _this.selectenObj.startSurplusDays!=''){
        _this.$message("请检查剩余天数输入");
      }else if(!this.$common.isNum(_this.selectenObj.endSurplusDays) && _this.selectenObj.endSurplusDays!=''){
        _this.$message("请检查剩余天数输入");
      }else if(!this.$common.isNum(_this.selectenObj.startInterUseCount) && _this.selectenObj.startInterUseCount!=''){
        _this.$message("请检查接口使用量输入");
      }else if(!this.$common.isNum(_this.selectenObj.endInterUseCount) && _this.selectenObj.endInterUseCount!=''){
        _this.$message("请检查接口使用量输入");
      }else{
        var terms=new Object();
        terms.page=_this.currentPage;
        terms.pageSize=_this.pagesize;
        //关键词
        terms.keyWord=_this.selectenObj.keyWord;
        //公司类型
        terms.comType=_this.selectenObj.companyType;
        //用户类型
        terms.userType=_this.selectenObj.userType;
        //当前状态
        terms.userStatus=_this.selectenObj.state;
        //付费方式
        terms.paymentType=_this.selectenObj.paymentMethod;
        //剩余日期
        terms.startSurplusDays=_this.selectenObj.startSurplusDays;
        terms.endSurplusDays=_this.selectenObj.endSurplusDays;
        //接口使用量
        if(_this.selectenObj.startInterUseCount==''){
          terms.startInterUseCount='';
        }else{
          terms.startInterUseCount=_this.selectenObj.startInterUseCount*10000;
        };
        if(_this.selectenObj.endInterUseCount==''){
          terms.endInterUseCount='';
        }else{
          terms.endInterUseCount=_this.selectenObj.endInterUseCount*10000;
        };
        // console.log("terms==================="+JSON.stringify(terms));
        _this.$axios.post('/requestApi/fee/find/list',terms)      
        .then(function(response){
          let data = response.data;
          // console.log("data==================="+JSON.stringify(data));
          if(data.meta.retCode==0){
            _this.resultDataTotal=data.data.totalCount;
            _this.resultData=data.data.resultList;
          }else{
            console.log(data.meta.friendlyMsg);
          }
        })
        .catch(function(error){
          console.log(error)
        });
      }
    },
    // 查询数据
    selectFun: function(){
      var _this=this;
      _this.currentPage=1;
      _this.clickSelectFun();
    },
    //查看
    detailsFun: function(id,type){
      if(type=='2'){
        this.$router.push({ path: '/ChargingDetailAfterpay', query: {id: id} });
      }else{
        this.$router.push({ path: '/ChargingDetailPrepay', query: {id: id} });
      }
    },
    //获取渠道字典
    getQdFun:function(){
      var _this=this;
      _this.$axios.get('/requestApi/dict/find/channel/dict')      
        .then(function(response){
          let data = response.data;
          if(data.meta.retCode==0){
            data.data.channel_dict.forEach(function(item){
              _this.qdOptions.push(item);
            });
          }else{
            _this.$message({
              message: data.meta.friendlyMsg,
              type: 'warning'
            });
          }
        })
        .catch(function(error){
          console.log(error)
        });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/components/ChargingManagement.vue